import { Pagination, createTable, Link as LinkMagik } from "@inmagik/magik-ui"
import { useMemo, useState } from "react"
import type { FiltersBase, Story } from "../../types"
import { PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<Story>()

export function TableStories({
  stories,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  stories: Story[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  // const [sort, setSort] = useState<string>("")
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  const numPages = useMemo(() => {
    if (!stories) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [stories, count])

  return (
    <Table
      data={stories}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Selection
        selectionField="id"
        selectedRows={selectedRows}
        onSelectionChange={(rows) => {
          setSelectedRows(rows)
        }}
      />

      <Table.Column
        title="Titolo"
        name="title"
        sortable
        width="minmax(max-content, 1fr)"
        render={(story) => (
          <Link to={`/stories/stories/${story.id}`}>
            <LinkMagik className="text-dark">{story.title}</LinkMagik>
          </Link>
        )}
        stickyLeft
        icon="person"
        // TODO badge
      />
      

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} storie
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
